import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const DetailedFiltersContent = styled.div<{ isMobileResolution: boolean }>`
    display: block;
    column-gap: 0.3rem;
    padding-top: 0rem;
    padding-bottom: 0rem;
    grid-template-columns: ${(props) => props.isMobileResolution && '2fr 3fr'};
`;

export const ColumnOne = styled.div`
    margin-bottom: 0;
`;

export const ColumnTwo = styled.div<{ isMobileResolution: boolean }>`
    grid-column: 2;
    grid-row: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    display: ${(props) => props.isMobileResolution && 'block'};
`;

export const DropdownWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 0 0.5rem 0;
    padding: 0;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 0.5em 0 0 0;
    min-width: 170px;
    max-width: 200px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FilterCategories = styled.div`
    display: grid;
    font-weight: bold;
`;
